import { Tab, TabList, TabPanel, Tabs } from '@welm/react-tabs';
import { Fragment, useRef, useState } from 'react';
import { BiMenu } from 'react-icons/bi';
import { MdOutlineQueryStats } from 'react-icons/md';
import { v4 as uuid } from 'uuid';
import noImage from '../assets/no-image.png';
import Grid from '../components/Grid';
import { AttachmentInput, CheckBoxInput, DBSelectInput, GroupInput, Input, MaskInput, SelectInput } from '../components/Input';
import { useSystemContext } from '../Context/SystemContext';
import Layout from '../Layout/Layout';
import { Changelog } from './Changelog';


const yup = require('../interface/yup-br');

export const SystemAdminPage = () => {
    const System = useSystemContext();
    const [Menu, setMenu] = useState(1);
    const [stats, setStats] = useState([]);
    const logoConsultorRef = useRef(null);
    if (System.property.user.level < 99) {
        return (
            <div>Sem permissão.</div>
        );
    }

    return (
        <Layout>
            <div className="min-h-screen mt-2 ml-2 grow-0">{MenuAdmin()}</div>
            <div className="w-2 grow-0 "></div>
            <div className="pt-2 grow">
                {Menu === 1 && TelaAdminEmpresas()}
                {Menu === 2 && TelaAdminUsers()}
                {Menu === 3 && CadastroConsultor()}
                {Menu === 4 && CadastroAdmins()}
                {Menu === 101 && TelaStatsCalls()}
                {Menu === 900 && TelaChangeLog()}
            </div>
        </Layout>
    );
    function TelaChangeLog() {
        return (
            <Fragment>
                <Changelog />
            </Fragment>
        );
    }
    function MenuAdmin() {
        function ItemMenu(itemID, text, subitem = false) {
            return (
                <div onClick={() => setMenu(itemID)} className={`cursor-pointer pl-4 hover:bg-gray-300 ${Menu === itemID ? 'bg-gray-200' : 'bg-white'} ${subitem ? 'ml-2' : null}`}>
                    {text}
                </div>
            );
        }
        return (
            <Fragment>
                <div className="rounded w-96 ">
                    <div className="inline-flex w-full pl-2 text-xl rounded-t h-7 bg-amarelo-eq">
                        <BiMenu className="mt-1 mr-1" /> Administraçãos
                    </div>
                    <div className="pl-2 text-left bg-white border-b border-l border-r">
                        <div className={`w-full`}>Cadastros</div>
                        <div>
                            {ItemMenu(1, 'Empresas')}
                            {ItemMenu(2, 'Usuários Master')}
                            {ItemMenu(3, 'Consultores')}
                            {ItemMenu(4, 'Administradores')}
                        </div>
                    </div>
                </div>
                <div className="mt-2 grow bg-yellow-50">
                    <div className="inline-flex w-full pl-2 text-xl rounded-t h-7 bg-amarelo-eq">
                        <BiMenu className="mt-1 mr-1" /> Estatísticas
                    </div>
                    <div className="pl-2 text-left bg-white border-b border-l border-r">
                        <div
                            onClick={async () => {
                                const response = await System.apiGet('/stats/calls');
                                setStats(response.data ?? []);
                                setMenu(101);
                            }
                            }
                            className={`cursor-pointer pl-4 hover:bg-gray-300 ${Menu === 101 ? 'bg-gray-200' : 'bg-white'}`}
                        >
                            Tráfego de dados
                        </div>
                    </div>
                </div>
                <div className="mt-2 grow bg-yellow-50">
                    <div className="inline-flex w-full pl-2 text-xl rounded-t h-7 bg-amarelo-eq">
                        <BiMenu className="mt-1 mr-1" /> Changelog
                    </div>
                    <div className="pl-2 text-left bg-white border-b border-l border-r">
                        <div
                            onClick={async () => {
                                setMenu(900);
                            }
                            }
                            className={`cursor-pointer pl-4 hover:bg-gray-300 ${Menu === 900 ? 'bg-gray-200' : 'bg-white'}`}
                        >
                            Alterações e novidades no sistema
                        </div>
                    </div>
                </div>
            </Fragment>

        );
    }
    function TelaAdminUsers() {
        return (
            <div className="mr-2 bg-white">
                <Grid
                    url={'/crew'}
                    url_post={'/crewmaster'}
                    filter={{ user: { level: 5 } }}
                    GridHeaders={[
                        {
                            title: 'Identificação',
                            field: 'identificacao',
                            sort: true,
                            className: 'w-1/12 text-left pl-1',
                        },
                        {
                            title: 'Nome',
                            field: 'nome',
                            sort: true,
                            className: 'w-6/12 pl-1 text-left border-l border-gray-300',
                        },
                        {
                            title: 'E-mail',
                            field: 'email',
                            sort: true,
                            className: 'w-4/12 pl-1 text-left border-l border-gray-300',
                        },
                        {
                            title: 'Status',
                            field: 'status',
                            sort: false,
                            className: 'w-1/12 pl-1 text-left border-l border-r border-gray-300',
                        },
                    ]}
                    GridTitle="Lista de Colaboradores"
                    LineDataPrint={(data) => {
                        if (data?.user?.level !== 5) return null;
                        return [data.identificacao, data.nome, data.email, data?.status];
                    }}
                    onRenderForm={(GridModes, SetFieldValue, values) => {
                        return (
                            <div>
                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                    <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                </div>
                                <GroupInput>
                                    <Input name="identificacao" label="Identificação" className={'w-1/3'} />
                                    <Input name="nome" label="Nome" />
                                </GroupInput>
                                <div className={'ml-2 mt-4 bg-amarelo-eq'}>Acesso ao Sistema</div>
                                <GroupInput>
                                    <Input name="email" label="Email" type="email" className={'w-4/6'} />
                                    <Input name="senha" label="Senha" className={'w-2/6'} />
                                </GroupInput>
                                <SelectInput name="status" label="Status colaborador" className={'inline-block'} listOptions={[{ value: 'Inativo' }, { value: 'Ativo' }]} />
                            </div>
                        );
                    }}
                    validationSchema={yup.object().shape({
                        nome: yup.string().required('Nome é obrigatório'),
                        identificacao: yup.string().required('Identificação é obrigatório'),
                        email: yup.string().required('Email é obrigatório'),
                        senha: yup.string().required('Senha é obrigatório'),
                        status: yup.string().required('Status é obrigatório'),
                    })}
                />
            </div>
        );
    }
    function CadastroConsultor(logotipo) {
        return (
            <>
                <div className="bg-white grow">
                    <div className="w-full border shadow">
                        <Grid
                            url={'/user'}
                            filter={{ level: 10 }}
                            key={uuid()}
                            disableModal
                            GridHeaders={[
                                {
                                    title: 'Nome',
                                    field: 'name',
                                    sort: true,
                                    className: 'w-6/12 text-left pl-1',
                                },
                                {
                                    title: 'E-mail',
                                    field: 'email',
                                    sort: true,
                                    className: 'w-3/12 pl-1 text-left border-l border-gray-300',
                                },
                                {
                                    title: 'Whatsapp',
                                    field: 'whatsapp',
                                    sort: true,
                                    className: 'w-2/12 pl-1 text-center border-l border-gray-300',
                                },
                                {
                                    title: 'Suporte',
                                    field: 'suporte',
                                    sort: true,
                                    className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                },
                            ]}
                            GridTitle="Cadastro de Consultores"
                            LineDataPrint={(item) => {
                                return [item.name, item.email, item.whatsapp, item.suporte ? '#color=red:Sim' : 'Não'];
                            }}
                            initialValues={{
                                name: '',
                                email: '',
                                password: '',
                                passwordConfirm: '',
                                level: 10,
                            }}
                            onPrepareSaveRecord={(values) => {
                                values.level = 10;
                                if (values.arquivo?.name) {
                                    let newForm = new FormData();
                                    for (let key in values) {
                                        newForm.append(key, values[key]);
                                    }
                                    return newForm;
                                }
                                return values;
                            }}
                            validationSchema={yup.object().shape({
                                name: yup.string().required('Nome é obrigatório'),
                                email: yup.string().email('Email inválido').required('Email é obrigatório'),
                                whatsapp: yup.string(),
                                logotipo: yup.string(),
                                usarlogotipo: yup.boolean(),
                                password: yup.string().required('Senha é obrigatória').min(6, 'Senha deve ter no mínimo 6 caracteres'),
                                passwordConfirm: yup
                                    .string()
                                    .required('Confirmação de senha é obrigatória')
                                    .oneOf([yup.ref('password'), null], 'Senhas não conferem'),
                            })}
                            onRenderForm={(GridModes, setFieldValue, values, GridRefresh) => {
                                if (logoConsultorRef && values?.logotipo !== null && values?.logotipo !== undefined) {
                                    (async () => {
                                        let l = await System.methods.apiGetImg(values.logotipo);
                                        logoConsultorRef.current.src = l || noImage;
                                    })();
                                }
                                return (
                                    <>
                                        <Input name="name" label="Nome" className="w-92" />
                                        <Input name="email" label="Email" className="w-92" type="email" />
                                        <GroupInput key={uuid()}>
                                            <MaskInput name="whatsapp" label="WhatsApp Suporte" mask="(99) 9 9999-9999" className={'w-1/2'} />
                                            <div className="px-2 pt-4 mt-3 ml-4">
                                                <CheckBoxInput name="suporte" label="Redirecionar suporte para este consultor" />
                                            </div>
                                        </GroupInput>
                                        <GroupInput>
                                            <img
                                                src={noImage}
                                                alt="Logotipo"
                                                ref={logoConsultorRef}
                                                title="Logotipo (120 x 53)"
                                                style={{
                                                    maxWidth: '120px',
                                                    maxHeight: '53px',
                                                }}
                                                className="w-40 my-2 ml-2 mr-8"
                                            />
                                            <AttachmentInput name="logotipo" label="Arquivo de Logotipo (120x53 px)" className="w-1/2" />
                                        </GroupInput>
                                        <CheckBoxInput name="usarlogotipo" label="Usar Logotipo do consultor no sistema" />
                                        <GroupInput className="mt-2">
                                            <Input name="password" label="Senha" type="password" />
                                            <Input name="passwordConfirm" label="Confirme" type="password" />
                                        </GroupInput>
                                    </>
                                );
                            }}
                            FormTabs={[
                                () => {
                                    return <div>Consultor</div>;
                                },
                                () => {
                                    return <div>Empresas</div>;
                                },
                            ]}
                            /*
                            // fazer no backend dentro do controller
                            onBeforeDelete={async (item) => {
                                // deletar todos os vinculos de empresas com o consultor
                                await System.apiDelete(`/consulant/unlink/${item._id}`);
                        }}
                        */
                            onRenderFormExtra={[
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div>
                                            {!GridModes.insert_mode && (
                                                <div className={'m-2'}>
                                                    <Grid
                                                        url={`/consulant/${item._id}`}
                                                        disableModal={true}
                                                        GridHeaders={[
                                                            {
                                                                title: 'Nome Fantasia',
                                                                field: 'nomeFantasia',
                                                                sort: true,
                                                                className: 'w-1/2 text-left pl-1',
                                                            },
                                                            {
                                                                title: 'Razão Social',
                                                                field: 'razaoSocial',
                                                                sort: true,
                                                                className: 'w-1/2 pl-1 text-left border-l border-gray-300',
                                                            },
                                                        ]}
                                                        GridTitle="Empresas vinculadas ao Consultor"
                                                        LineDataPrint={(data) => {
                                                            return [data.company?.nomeFantasia, data.company?.razaoSocial];
                                                        }}
                                                        onRenderForm={() => {
                                                            return (
                                                                <div className="w-full">
                                                                    <DBSelectInput name="company_id" label="Empresa" url="/company" displaySelectField="nomeFantasia" />
                                                                </div>
                                                            );
                                                        }}
                                                        validationSchema={() => {
                                                            return yup.object().shape({
                                                                company_id: yup.string(),
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                },
                            ]}
                        />
                    </div>
                </div>
            </>
        );
    }
    function CadastroAdmins() {
        return (
            <>
                <div className="bg-white grow">
                    <div className="w-full border shadow">
                        <Grid
                            url={'/user'}
                            filter={{ level: 99 }}
                            GridHeaders={[
                                {
                                    title: 'Nome',
                                    field: 'name',
                                    sort: true,
                                    className: 'w-1/2 text-left pl-1',
                                },
                                {
                                    title: 'E-mail',
                                    field: 'email',
                                    sort: true,
                                    className: 'w-1/2 pl-1 text-left border-l border-gray-300',
                                },
                            ]}
                            GridTitle="Cadastro de Administradores"
                            LineDataPrint={(item) => {
                                return [item.name, item.email];
                            }}
                            onPrepareSaveRecord={(values) => {
                                values.level = 99;
                                if (values.arquivo?.name) {
                                    let newForm = new FormData();
                                    for (let key in values) {
                                        newForm.append(key, values[key]);
                                    }
                                    return newForm;
                                }
                                return values;
                            }}
                            onRenderForm={(GridModes) => {
                                return (
                                    <>
                                        <Input name="name" label="Nome" className="w-92" />
                                        <Input name="email" label="Email" className="w-92" type="email" />
                                        <GroupInput>
                                            <Input name="password" label="Senha" type="password" />
                                            <Input name="passwordConfirm" label="Confirme" type="password" />
                                        </GroupInput>
                                    </>
                                );
                            }}
                            initialValues={{
                                name: '',
                                email: '',
                                password: '',
                                passwordConfirm: '',
                                level: 99,
                            }}
                            validationSchema={yup.object().shape({
                                name: yup.string().required('Nome é obrigatório'),
                                email: yup.string().email('Email inválido').required('Email é obrigatório'),
                                password: yup.string().required('Senha é obrigatória').min(6, 'Senha deve ter no mínimo 6 caracteres'),
                                passwordConfirm: yup
                                    .string()
                                    .required('Confirmação de senha é obrigatória')
                                    .oneOf([yup.ref('password'), null], 'Senhas não conferem'),
                            })}
                        />
                    </div>
                </div>
            </>
        );
    }
    function TelaAdminEmpresas() {
        function MudaStatusEmpresa(GridData, id) {
            GridData.forEach((item) => {
                if (item._id === id) {
                    item.ativa = !item.ativa;
                    System.apiPut(`/company-status/${id}`, { ativa: item.ativa }).then((res) => {
                        if (res.status === 200) {
                            System.methods.notificationSuccess('Status da empresa alterado!');
                        }
                    });
                }
            });
            return false;
        }
        return (
            <>
                <div className="bg-white grow">
                    <div className="w-full border shadow">
                        <Grid
                            GridHooks={{
                                checkboxHook: MudaStatusEmpresa,
                            }}
                            url={'/company'}
                            canDelete={false}
                            disableModal={true}
                            GridHeaders={[
                                { title: 'Nome Fantasia', field: 'nomeFantasia', sort: true, className: 'w-5/12 text-left pl-1' },
                                { title: 'Razão Social', field: 'razaoSocial', sort: true, className: 'w-5/12 pl-1 text-left border-l border-gray-300' },
                                { title: 'Norma', field: 'norma', sort: true, className: 'w-1/12 pl-1 text-center border-l border-gray-300' },
                                { title: 'Ativa', field: 'ativa', sort: true, className: 'w-1/12 pl-1 text-center border-l border-gray-300' },
                            ]}
                            GridTitle="Cadastro de Empresas"
                            LineDataPrint={(item) => {
                                return [
                                    item.nomeFantasia, //
                                    item.razaoSocial, //
                                    item.norma, //
                                    `#checkbox=${item.ativa}:checkboxHook:${item._id}`, //
                                ];
                            }}
                            onRenderForm={(GridModes, SetFieldValue, values) => {
                                return (
                                    <div>
                                        <div className="inline-flex w-full h-6 pl-2 justify-left bg-amarelo-eq">
                                            Cadastro de empresa
                                        </div>
                                        <GroupInput>
                                            <Input name="nomeFantasia" label="Nome Fantasia" className={"w-1/2"} />
                                            <Input name="razaoSocial" label="Razão Social" className={"w-1/2"} />
                                        </GroupInput>
                                        <GroupInput>
                                            <SelectInput
                                                name="ativa"
                                                label="Status da empresa"
                                                className="inline-block w-40"
                                                listOptions={[
                                                    { value: true, option: 'Ativa' },
                                                    { value: false, option: 'Inativa' },
                                                ]}
                                            />
                                        </GroupInput>

                                        <GroupInput>
                                            <span className='mt-3 ml-2 font-semibold'>Parametrizações do Sistema</span>
                                        </GroupInput>
                                        <div className='m-2 h-96'>
                                            <Tabs>
                                                <TabList>
                                                    <Tab>Geral</Tab>
                                                    <Tab>Pendências</Tab>
                                                    <Tab>Colaboradores</Tab>
                                                    <Tab>7.1.2</Tab>
                                                    <Tab>7.5</Tab>
                                                    <Tab>8.5.1</Tab>
                                                    <Tab>8.5.3</Tab>
                                                    <Tab>10.2</Tab>
                                                </TabList>
                                                <TabPanel name="tabGeral">
                                                    <div className='inline-flex flex-col w-1/3'>
                                                        <SelectInput
                                                            name="norma"
                                                            label="Norma"
                                                            className="inline-block w-1/2"
                                                            listOptions={[
                                                                {
                                                                    value: 'ISO-9001',
                                                                },
                                                                {
                                                                    value: 'SGI',
                                                                },
                                                                {
                                                                    value: 'RDC-665',
                                                                },
                                                                {
                                                                    value: 'LGPD',
                                                                },
                                                            ]}
                                                        />
                                                        <CheckBoxInput
                                                            name="usarLogoSistema"
                                                            label="Permite usar logotipo próprio no sistema."
                                                            className={'mt-2'}
                                                        />
                                                        <CheckBoxInput
                                                            name="usarSMTPExterno"
                                                            label="Permite usar servidor de e-mail externo."
                                                            information="Esta opção habilita a exibição da confguração de de servidor de email na area de Configurações da empresa."
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />
                                                        <CheckBoxInput
                                                            name="usarPermissoesEspeciais"
                                                            label="Permite delegar privilégios especiais para uma função."
                                                            information="Esta opção habilita a as permissões especiais no cadastro de funções, dado possibilidade de uma função poder cadastrar Usuários, Provedores e Treinamentos."
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />
                                                        <CheckBoxInput
                                                            name="enviarPendenciasParaConsultor"
                                                            label="Notificar consultor das pendências do Dashboard"
                                                            information="Esta função envia todas as notificações de pendências para os consultores vinculados a esta empresa."
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />
                                                    </div>
                                                    <div className='inline-flex flex-col w-1/3'>
                                                    </div>
                                                    <div className='inline-flex flex-col w-1/3'>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel name="Pendências">
                                                    <div className='inline-flex flex-col w-1/3'>
                                                        <CheckBoxInput
                                                            name="pendenciaMail"
                                                            label="Envio de e-mail das Pendências (Dashboard)"
                                                            className={'mt-2'}
                                                        />
                                                        <CheckBoxInput
                                                            name="pendencia_apenas_master"
                                                            label="Enviar pendências apenas para Masters"
                                                            disabled={!values.pendenciaMail}
                                                            className={'mt-2'}
                                                        />
                                                        <CheckBoxInput
                                                            name="pendencia_alerta_24h"
                                                            label="Alerta Crítico de pendências"
                                                            information="Envia alerta de pendências que vencem nas próximas 24 Hs (5.4, 6.1, 6.1.2, 6.3, 7.1.2, 7.1.3, 7.1.4, 7.1.5, 7.5.3 e 10.2)"
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />
                                                    </div>
                                                    <div className='inline-flex flex-col w-1/3'>
                                                        <CheckBoxInput
                                                            name="pendenciaVencidaMail"
                                                            label="Enviar pendências vencidas"
                                                            disabled={!values.pendenciaMail}
                                                            className={'mt-2'}
                                                        />
                                                        <Input
                                                            name="pendenciaMailDias"
                                                            type="number"
                                                            label="Dias para considerar vencida"
                                                            title="Dias após a data atual considerado prestes a vencer"
                                                            className="inline-block"
                                                            min="5"
                                                            max="120"
                                                        />
                                                    </div>
                                                </TabPanel>
                                                <TabPanel name="Colaboradores">
                                                    <div className='inline-flex flex-col w-1/3'>
                                                        <CheckBoxInput
                                                            name="usarValidadeSenhaColaborador"
                                                            label="Controlar validade da senha do colaborador"
                                                            information="Habilita os campos Dias de validade e ultima alteração da senha do colaborador assim como visualizacao no dashboard."
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />
                                                        <CheckBoxInput
                                                            name="usarFotoColaborador"
                                                            label="Permite foto do colaborador"
                                                            information="Habilita os campos de foto, permitindo, cadastrar, alterar ou remover a foto do colaborador."
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />

                                                    </div>
                                                </TabPanel>
                                                <TabPanel name="tab712">
                                                    <GroupInput>
                                                        <CheckBoxInput
                                                            name="ativaCertificacaoOEA"
                                                            label="Ativar certificação OEA"
                                                            information="Esta função habilita o uso de campos específicos da certificação OEA."
                                                            checkedValue={true}
                                                            uncheckedValue={false}
                                                            className={'mt-2'}
                                                        />
                                                    </GroupInput>
                                                </TabPanel>
                                                <TabPanel name="tab75">
                                                    <GroupInput>
                                                        <SelectInput
                                                            name="ativaVinculoProcessos"
                                                            label="Ativar vinculo de processo/subprocesso no 7.5"
                                                            title="Apenas documentos vínculados ao colaborador serão exibidos"
                                                            className="inline-block w-1/3"
                                                            defaultValue={false}
                                                            listOptions={[
                                                                { value: true, option: 'Ativo' },
                                                                { value: false, option: 'Inativo' },
                                                            ]}
                                                        />
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <SelectInput
                                                            name="formatoprocessos"
                                                            label="Uso do Processo e Subprocesso"
                                                            title="Formato de uso do campo processo e sub-processo"
                                                            className="inline-block w-1/3"
                                                            defaultValue={'txt'}
                                                            listOptions={[
                                                                { value: 'txt', option: 'Apenas campo texto do processo' },
                                                                { value: 'processo', option: 'Seleção de processo' },
                                                                { value: 'processoesub', option: 'Processo e Subprocesso' },
                                                            ]}
                                                        />
                                                    </GroupInput>
                                                </TabPanel>
                                                <TabPanel name="tab851">
                                                    <GroupInput>
                                                        <div className="pt-2 mt-2">
                                                            <CheckBoxInput name="controleLaudos851" label="Ativar laudos de inspeção alimentar" />
                                                        </div>
                                                    </GroupInput>
                                                </TabPanel>
                                                <TabPanel name="tab853">
                                                    <GroupInput>
                                                        <SelectInput
                                                            name="integrarCadastroClientes853"
                                                            label="Integrar cadastro de clientes"
                                                            title="Ativa a integração do cadastro de clientes com o módulo"
                                                            className="inline-block w-1/3"
                                                            defaultValue={false}
                                                            listOptions={[
                                                                { value: true, option: 'Integrado' },
                                                                { value: false, option: 'Normal (Permite digitar nome cliente)' },
                                                            ]}
                                                        />
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <div className="pt-2 mt-2">
                                                            <CheckBoxInput name="controleLaudos853" label="Ativar Controle de Laudos" />
                                                        </div>
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <div className="pt-2 mt-2">
                                                            <CheckBoxInput name="controleLaudos853visitante" label="Ativar visualização de Laudos pelos Clientes (https://guest.eqsgt.com.br)" />
                                                        </div>
                                                    </GroupInput>

                                                </TabPanel>
                                                <TabPanel name="tab102">
                                                    <GroupInput>
                                                        <SelectInput
                                                            name="ativaNaoConformidadeSimples"
                                                            label="Cadastro de não Conformidade (10.2) -  Simplificada"
                                                            title="Simplifica a tela de cadastroi de não conformidadde 10.2"
                                                            className="inline-block w-1/2"
                                                            defaultValue={false}
                                                            listOptions={[
                                                                { value: true, option: 'Simplificada' },
                                                                { value: false, option: 'Normal' },
                                                            ]}
                                                        />
                                                    </GroupInput>
                                                </TabPanel>
                                            </Tabs>
                                        </div>
                                    </div>
                                );
                            }}
                            validationSchema={yup.object().shape({
                                nomeFantasia: yup.string().required(),
                                razaoSocial: yup.string().required(),
                                norma: yup.string(),
                            })}
                        />
                    </div>
                </div >
            </>
        );
    }
    function TelaStatsCalls() {
        const globalCalls = stats.reduce((total, item) => total + (item.totalrequests || 0), 0);
        //console.log(globalCalls);
        return (
            <div className="mr-2 ">
                <div className="inline-flex w-full pl-2 text-xl rounded-t h-7 bg-amarelo-eq">
                    <MdOutlineQueryStats className="mt-1 mr-1" />Tráfego de dados {stats.length > 0 && ` - ${stats[0].periodo}`}
                </div>
                {stats.length > 0 && (
                    <div className='mt-2 bg-white border'>
                        <table className="w-full border ">
                            <thead>
                                <tr className="border-b border-gray-300 bg-amarelo-eq">
                                    <th className="w-4/12 pl-2 text-left">Empresa</th>
                                    <th className="w-1/12 pl-2 text-left">Ler</th>
                                    <th className="w-1/12 pl-2 text-left">Alterar</th>
                                    <th className="w-1/12 pl-2 text-left">Criar</th>
                                    <th className="w-1/12 pl-2 text-left">Excluir</th>
                                    <th className="w-1/12 pl-2 text-left">Total</th>
                                    <th className="w-2/12 pl-2 text-center">Global</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stats.map((item) => (
                                    <tr key={item._id} className="border-b border-gray-300">
                                        <td className="pl-2">{item.nomeFantasia}</td>
                                        <td className="pl-2">{item.getrequest}</td>
                                        <td className="pl-2">{item.putrequest}</td>
                                        <td className="pl-2">{item.postrequest}</td>
                                        <td className="pl-2">{item.delrequest}</td>
                                        <td className="pl-2">{item.totalrequests}</td>
                                        <td className="relative pl-2 text-center">
                                            <div
                                                className="absolute top-0 left-0 h-full bg-blue-200"
                                                style={{ width: `${((item.totalrequests / globalCalls) * 100).toFixed(2)}%` }}
                                            ></div>
                                            <span className="relative">{((item.totalrequests / globalCalls) * 100).toFixed(2)}%</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

};



